var React = require('react');

function Warning2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.7363 3.02355C23.5161 1.68676 25.4535 1.70415 26.2092 3.05472L46.3345 39.0234C47.0805 40.3566 46.1168 42 44.5892 42H3.48207C1.93849 42 0.97675 40.3256 1.75452 38.9923L22.7363 3.02355Z","fill":"#D63D3D","key":0}),React.createElement("rect",{"x":"23","y":"15","width":"3","height":"14","fill":"white","key":1}),React.createElement("circle",{"cx":"24.5","cy":"32.5","r":"1.5","fill":"white","key":2})]);
}

Warning2.defaultProps = {"width":"48","height":"42","viewBox":"0 0 48 42","fill":"none"};

module.exports = Warning2;

Warning2.default = Warning2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/Warning-2.svg
// module id = 927
// module chunks = 0